import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { TransfertResponsabiliteService } from '../services/transfert-responsabilite.service';
import { Subject } from 'rxjs';
import { SimplifiedTransfert } from '../entities/simplified-transfert.entity';

const etatLabels: string[] = ['initialisé', 'accepté', 'confirmé', 'annulé', 'refusé', 'terminé'];

@Component({
	selector: 'historique-transferts',
	templateUrl: 'historique-transferts.html',
	styleUrls: ['historique-transferts.css'],
})
export class HistoriqueTransfertsComponent implements AfterViewInit {
	
	possibleEtats = etatLabels;
	dataSource = new MatTableDataSource<SimplifiedTransfert>([]);
	isLoading = true;
	exportRequests$ = new Subject<void>();
	displayedColumns: string[] = ['id', 'date', 'emetteur', 'destinataire', 'cac', 'etat', 'perimetre'];

	@ViewChild(MatPaginator) paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;

	constructor(@Inject(TransfertResponsabiliteService) private transfertResponsabiliteService: TransfertResponsabiliteService) {
		this.transfertResponsabiliteService.getTransferts().subscribe((transferts) => {
			transferts.forEach(transfert => {
				if (transfert.parcsComplets?.length) {
					transfert.parcsCompletCodes = transfert.parcsComplets.join(', ');
				}
				if (transfert.parcsIncomplets?.length) {
					transfert.parcsIncomplets.forEach(parcIncomplet => {
						parcIncomplet.ouvrageCodes = parcIncomplet.ouvrages.map(o => o.nom).join(', ');
						parcIncomplet.sousParcs.forEach(sousParc => {
							if (sousParc.ouvrages?.length) {
								sousParc.ouvrageCodes = sousParc.ouvrages.map(o => o.nom).join(', ');
							}
						});
					});
				}
			});

			this.dataSource.data = transferts;
			this.isLoading = false;
		});
		this.exportRequests$.subscribe(
			() => {
				// Lancer la generation et le download du excel
				this.transfertResponsabiliteService.export().subscribe(
					(blob: Blob) => {
						const objectUrl: string = URL.createObjectURL(blob);
						const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
						a.href = objectUrl;
						a.download = "export-transferts.xls";
						document.body.appendChild(a);
						a.click();
						
						document.body.removeChild(a);
						URL.revokeObjectURL(objectUrl);
					},
					(err: any) => {
						alert("Erreur lors du téléchargement de l'export");
						console.log('Could not generate the file, error: ', err);
					}
				);		
				
			}
		);
	}

	ngAfterViewInit() {
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;

		this.dataSource.sortingDataAccessor = (item, property) => {
		  switch (property) {
		    case 'id': return item.data.id;
		    case 'date': 
		      if (Array.isArray(item.data.dateTransfert)) {
		        const [year, month, day, hour, minute, second] = item.data.dateTransfert;
		        return new Date(year, month - 1, day, hour, minute, second).getTime();
		      }
		      return 0;
		    case 'emetteur': return item.emetteur;
		    case 'destinataire': return item.destinataire;
		    case 'cac': return item.data.responsabilite;
		    case 'type': return item.type ? 'Local' : 'Distant';
		    case 'etat': return item.data.etat;
		    default: return (item as any)[property] ?? '';
		  }
		};

	}
}
